import React, { useState } from "react";
import { styled } from "@mui/system";
import emailjs from "@emailjs/browser";
import {
  Title, Subtitle, CTASection, CTAText, EmailFormWrapper, EmailInput, JoinButton, SectionContainer,
  BoxContainer,
  Card,
  CardText,
  BoxContainerTitle
} from "../assets/styles/ContentStyles"
import EmailInputComponent from "./EmailInputComponent";

const DeviceSecurityForAll = () => {

  const features = [
    {
      title: "Real-Time Protection",
      description:
        "Receive instant alerts the moment a new vulnerability or exploit is discovered for any of your devices—not weeks later when it's already been exploited.",
    },
    {
      title: "Simple Guidance",
      description:
        "No technical jargon. We tell you exactly what the risk is and provide step-by-step instructions to protect yourself, whether that's changing a setting or contacting the manufacturer.",
    },
    {
      title: "Complete Visibility",
      description:
        "Monitor all your devices from a single dashboard. See which ones are secure, which need attention, and track your overall security posture with our risk scoring system.",
    },
  ];

  return (
    <SectionContainer>
      <Title>Device Security For the Rest of Us</Title>

      <Subtitle>
        Hackable Devices continuously monitors your connected devices and translates complex
        security data into clear, actionable information – no PhD in Cybersecurity required.
      </Subtitle>

      <BoxContainer>
        {features.map((feature, index) => (
          <Card key={index}>
            <BoxContainerTitle>{feature.title}</BoxContainerTitle>
            <CardText>{feature.description}</CardText>
          </Card>
        ))}
      </BoxContainer>

      <CTASection>
        <CTAText>
          Get real-time device security monitoring & patching from Hackable Devices.
        </CTAText>

        <EmailInputComponent waitlistType="Device Security For All - Monitoring & Patching" />
      </CTASection>
    </SectionContainer>
  );
};

export default DeviceSecurityForAll;
